<template>
  <div
    class="socialLink"
    :class="{ 'socialLink--lg': size === 'large' }"
  >
    <a
      class="--no-style"
      href="https://www.facebook.com/smapshot/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <IconWrap
        name="Facebook"
        :width="svgSize"
        :height="svgSize"
      >
        <IconFacebook />
      </IconWrap>
    </a>
    <a
      class="--no-style"
      href="https://twitter.com/search?q=%23smapshot&amp;src=typd"
      target="_blank"
      rel="noopener noreferrer"
    >
      <IconWrap
        class="mx-2"
        name="Twitter"
        :width="svgSize"
        :height="svgSize"
      >
        <IconTwitter /> </IconWrap><span>#smapshot</span>
    </a>
  </div>
</template>

<script>
import IconFacebook from '@/assets/images/icons/Facebook';
import IconTwitter from '@/assets/images/icons/Twitter';
import IconWrap from '@/assets/images/icons';

export default {
  name: 'NavSocialLinks',

  components: {
    IconWrap,
    IconFacebook,
    IconTwitter
  },

  props: {
    size: {
      type: String,
      default: 'normal'
    }
  },

  computed: {
    svgSize() {
      return this.size === 'large' ? 24 : 18;
    }
  }
};
</script>

<style lang="postcss" scoped>
.socialLink{
  @apply flex items-center;

  & a{
    @apply flex items-center text-teal-300 no-underline;
    letter-spacing: 0.0833333em;
  }

  & a span {
    @apply text-teal-500;
  }

  & a:hover{
    @apply text-teal-400;
  }

  &.socialLink--lg a{
    @apply text-lg;
  }
}

.modeContribute .socialLink{
  & a{
    @apply text-orange-300;
  }
  & a span {
    @apply text-orange-500;
  }
  & a:hover{
     @apply text-orange-400;
  }
}
</style>
